import { Card, CardContent, Grid, ListItemText, ListItem, TextField, Typography, List, Box } from '@mui/material';
import { SCUIBreadCrumb } from '../../atomic/molecules';
import { SCUIContent } from '../../atomic/organisms';
import { SCUIButton, SCUILoadingLinear } from '../../atomic/atoms';
import { useState } from 'react';
import { t } from 'i18next';
import CopyToClipboardButton from '../../atomic/atoms/SCUICopyToClipboardButton/SCUICopyToClipboardButton';
import NoOrderShotSearchQuery from '../../services/query/noOrderShotSearch/NoOrderShotSearch.services';
import Swal from 'sweetalert2';
import { NOSS } from './noOrderShotSearch.classes';

export const NoOrderShotSearch = () => {
    const [orderNumbers, setOrderNumbers] = useState('');
    const [loading, setLoading] = useState<boolean>(false);
    const [notFoundIds, setNotFoundIds] = useState<any[]>([]);

    const getNoOrderShotSearch = async (orderNumbers: string) => {
        try {
            setLoading(true);
            const orderNumbersList = orderNumbers
                .split(/[\n,]/)
                .filter((x: any) => x !== '' && x !== null && x !== undefined)
                .map((x: string) => x.trim().substring(0, 13))
                .map((x: string) => parseInt(x, 10));

            const response = await NoOrderShotSearchQuery.GetNoOrderShotSearch({ orderNumbers: orderNumbersList });

            setNotFoundIds(response.data?.map((item: any) => item.orderNumber) || []);
        } catch {
            Swal.fire(t('general.error'), t('general.anErrorOccured'), 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <SCUIContent>
            <Grid className={NOSS.page}>
                <div className={NOSS.breadcrumbSection}>
                    <SCUIBreadCrumb
                        title={t('noOrderShotSearch.pageTitle')}
                        componentLink={'/no-order-shot-search'}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
                <Grid
                    className={NOSS.loadingSection}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    {loading && <SCUILoadingLinear display={loading} />}
                </Grid>
                <Grid className={NOSS.mainLayout} container sx={{ paddingTop: 2 }}>
                    <Grid
                        className={NOSS.inputColumn}
                        size={{
                            xs: 4,
                            md: 4,
                            lg: 4,
                            xl: 4,
                        }}
                    >
                        <TextField
                            className={NOSS.inputTextOrderNumbers}
                            label={t('general.orderNumber') as string}
                            multiline={true}
                            rows={10}
                            onChange={(event: any) => {
                                setOrderNumbers(event.target.value);
                            }}
                            value={orderNumbers}
                            slotProps={{ inputLabel: { shrink: true } }}
                            sx={{ marginBottom: 1, width: 250 }}
                        />
                        <div className={NOSS.actionsRow} style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                            <div className={NOSS.clearButtonWrap} style={{ position: 'relative', zIndex: 3 }}>
                                <SCUIButton
                                    className={NOSS.inputButtonClear}
                                    text={t('general.clear')}
                                    type="error"
                                    buttonType="submit"
                                    sizeType="default"
                                    size="m"
                                    style={{ width: 110, borderRadius: '4px' }}
                                    onClick={() => {
                                        setOrderNumbers('');
                                        setNotFoundIds([]);
                                    }}
                                />
                            </div>
                            <div className={NOSS.searchButtonWrap} style={{ position: 'relative', zIndex: 2 }}>
                                <SCUIButton
                                    className={NOSS.inputButtonSearch}
                                    text={t('general.search')}
                                    type="primary"
                                    buttonType="submit"
                                    sizeType="default"
                                    size="m"
                                    style={{ width: 110, borderRadius: '4px' }}
                                    onClick={() => getNoOrderShotSearch(orderNumbers)}
                                />
                            </div>
                        </div>
                    </Grid>
                    <Grid
                        className={NOSS.resultsColumn}
                        style={{ maxHeight: '250px', width: 200 }}
                        size={{
                            xs: 8,
                            md: 8,
                            lg: 8,
                            xl: 8,
                        }}
                    >
                        {notFoundIds.length > 0 && (
                            <Card className={NOSS.resultsCard} sx={{ height: '100%', width: 250 }}>
                                <CardContent>
                                    <Box className={NOSS.resultsTitleRow} sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 1 }}>
                                        <Typography variant="h6" color={'red'}>
                                            {t('noOrderShotSearch.notFoundIds') as string}
                                        </Typography>
                                        {notFoundIds && Array.isArray(notFoundIds) && notFoundIds.length > 0 && (
                                            <span className={NOSS.copyResultsButtonWrap}>
                                                <CopyToClipboardButton
                                                    textToCopy={notFoundIds.filter((val) => val !== undefined).join('\n')}
                                                />
                                            </span>
                                        )}
                                    </Box>

                                    <div className={NOSS.resultsListWrap} style={{ maxHeight: '150px', overflow: 'scroll', width: 200 }}>
                                        <List className={NOSS.resultsList}>
                                            {notFoundIds.map((val: any, index: number) => (
                                                <ListItem className={NOSS.resultsListItem} key={index}>
                                                    <ListItemText primary={`${val}`} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </div>
                                </CardContent>
                            </Card>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
